import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {type PaymentData} from './payments';

export function paymentPatcher(data: PaymentData): RestTypeWithTypename<PaymentData> {
    return {
        __typename: 'PaymentData',
        ...data,
        payments: data.payments.map(method => ({
            __typename: 'Payment',
            ...method,
            behaviors: method.behaviors.map(behavior => ({__typename: 'PaymentBehavior', ...behavior})),
        })),
        billPayers: data.billPayers.map(billPayer => ({
            __typename: 'paymentBillpayer',
            ...billPayer,
        })),
    };
}
